import ChooseTargetJobStep from '../components/job-title-recommender/choose-target-job-step.vue';
import ConfirmSelection from '../components/job-title-recommender/confirm-selection-step.vue';

const selectionTypes = {
	INPUT: 'input',
	OPTION: 'option',
};

const steps = {
	CHOOSE_TARGET_JOB: 'chooseTargetJob',
	CONFIRM_SELECTION: 'confirmSelection',
};

const stepComponents = {
	[steps.CHOOSE_TARGET_JOB]: ChooseTargetJobStep,
	[steps.CONFIRM_SELECTION]: ConfirmSelection,
};

const errorTypes = {
	FAIL_FETCHING_RECOMMENDED_TITLES: 'failFetchingRecommendedTitles',
	FAIL_MISSING_RECOMMENDED_TITLES: 'failMissingRecommendedTitles',
	FAIL_EVALUATING_TITLE: 'failureEvaluatingTitle',
	SOMETHING_WENT_WRONG: 'somethingWentWrong',
};

const errorMessages = {
	failFetchingRecommendedTitles:
        'We were not able to generate your titles. Please refresh the page and check again in a few minutes.',
	failMissingRecommendedTitles:
        'Your Primary Resume does not have enough content. Please add more experiences or set a new Primary Resume.',
	failureEvaluatingTitle:
        'We were not able to compare your resume and target title. Please refresh the page and check again in a few minutes.',
	somethingWentWrong: 'Something went wrong. Please try again later or refresh the page.',
};

export { steps, selectionTypes, stepComponents, errorMessages, errorTypes };
